import script from "./edit-banner.vue?vue&type=script&setup=true&lang=js"
export * from "./edit-banner.vue?vue&type=script&setup=true&lang=js"

import "./edit-banner.vue?vue&type=style&index=0&id=34b87f40&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34b87f40"]])

export default __exports__